import { useFormikContext } from 'formik';
import { useState } from 'react';
import { Button } from 'react-bootstrap';
import TextField from 'src/app/modules/component/TextField';
import PhieuDieuTriDialog from './PhieuDieuTriDialog';
import { toast } from 'react-toastify';

const ThongTinSinhHieu = (props: any) => {
	const { setValues, values } = useFormikContext<any>();
	const [openTreatmentDialog, setOpenTreatmentDialog] = useState(false);
	const { patientInfo } = props || {};

	const onPhieuDieuTriSelect = (rowData: any) => {
		setValues({
			...values,
			pr: rowData.pr,
			bt: rowData.bt,
			bpSys: rowData.bpSys,
			bpDia: rowData.bpDia,
			rr: rowData.rr,
			height: rowData.height,
			weight: rowData.weight,
		});
		setOpenTreatmentDialog(false);
		toast.success('Cập nhật thông tin từ phiếu điều trị thành công');
	};

	return (
		<div className="text-center">
			<Button
				className="link-info bg-white text-decoration-underline"
				onClick={() => {
					setOpenTreatmentDialog(true);
				}}
			>
				Cập nhật từ phiếu điều trị
			</Button>

			<div className="border spaces p-8 mt-6">
				<div className="d-flex justify-content-between align-items-end spaces">
					<TextField
						label="Mạch"
						name="forms.pr"
						className="text-center spaces max-w-200"
					/>
					<label className="text-lable-input">
						<em>lần/phút</em>
					</label>
				</div>
				<div className="d-flex justify-content-between align-items-end spaces pt-2">
					<TextField
						label="Nhiệt độ"
						name="forms.bt"
						className="text-center spaces max-w-200"
					/>
					<label className="text-lable-input">
						<em>°C</em>
					</label>
				</div>
				<div className="d-flex justify-content-between align-items-end spaces pt-2">
					<TextField
						label="Huyết áp"
						name="forms.bpSys"
						className="text-center spaces max-w-200"
					/>
					<label className="text-lable-input">
						<em>/</em>
					</label>
					<TextField
						name="forms.bpDia"
						className="text-center spaces max-w-200"
					/>
					<label className="text-lable-input">
						<em>mmHG</em>
					</label>
				</div>
				<div className="d-flex justify-content-between align-items-end spaces pt-2">
					<TextField
						label="Nhịp thở"
						name="forms.rr"
						className="text-center spaces max-w-200"
					/>
					<label className="text-lable-input">
						<em>lần/phút</em>
					</label>
				</div>
				<div className="d-flex justify-content-between align-items-end spaces pt-2">
					<TextField
						label="Chiều cao"
						name="forms.height"
						className="text-center spaces max-w-200"
					/>
					<label className="text-lable-input">
						<em>cm</em>
					</label>
				</div>
				<div className="d-flex justify-content-between align-items-end spaces pt-2">
					<TextField
						label="Cân nặng"
						name="forms.weight"
						className="text-center spaces max-w-200"
					/>
					<label className="text-lable-input">
						<em>kg</em>
					</label>
				</div>
			</div>

			{openTreatmentDialog && (
				<PhieuDieuTriDialog
					open={openTreatmentDialog}
					onClose={() => setOpenTreatmentDialog(false)}
					onSave={onPhieuDieuTriSelect}
					params={{
						patientId: patientInfo?.id,
						visitId: patientInfo?.visitId,
						medicalRecordCode: patientInfo?.medicalRecordCode,
					}}
				/>
			)}
		</div>
	);
};

export default ThongTinSinhHieu;
